import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { observer } from 'mobx-react'
import React, { useCallback, useEffect } from 'react'
import InputField from './InputField/InputField'

function FormInput({
  onChange,
  caption,
  containerStyles,
  autoSearch,
  multiple,
  onChangeMultiple,
  validateFilterInputs,
  capitalizeFirstLetter,
  styles,
  ignoreErrorColor,
  error,
  onlyNumbers,
  ...props
}) {
  const validate = (event, propName) => {
    const numericPropNames = [
      'external-tracking-number',
      'receiverSerialNumber',
    ]
    const propNamesNotSimbolsNumbrs = ['name', 'surname', 'patronymic']
    const propNamesNotSimbols = [
      'house',
      'building',
      'apartment',
      'additionalInfo',
      'address',
    ]

    if (numericPropNames.includes(propName)) {
      const numericRegex = /^[0-9]+$/
      return (
        numericRegex.test(event.target?.value ? event.target.value : event) ||
        event.target.value === ''
      )
    }

    if (propNamesNotSimbolsNumbrs.includes(propName)) {
      const regex = /^[^<>"{}()123456789*/|\\!@#$%^&]+$/

      return regex.test(event.target?.value ? event.target.value : event) ||
        event.target.value === ''
        ? true
        : false
    }

    if (propNamesNotSimbols.includes(propName)) {
      const regex = /^[^<>"{}()*/|\\!@#$%^&]+$/

      return (
        regex.test(event.target?.value ? event.target.value : event) ||
        event.target.value === ''
      )
    }

    if (propName === 'locality') {
      const regex = /^[^<>"{}*/|\\!@#$%^&]+$/

      return regex.test(event.target?.value ? event.target.value : event) ||
        event.target.value === ''
        ? true
        : false
    }

    return true
  }

  const onChangeAction = useCallback(
    (event) => {
      if (capitalizeFirstLetter) {
        event.target.value =
          event.target.value.charAt(0).toUpperCase() +
          event.target.value.slice(1)
      }
      if (onChange) {
        const value = event.target ? event.target.value : event
        if (onlyNumbers) {
          nums.test(value) && onChange(value)
        } else {
          onChange(value)
        }
      } else {
        if (multiple) {
          onChangeMultiple(event)
          return
        }
        if (props.type === 'checkbox') {
          props.api.data[props.propName] = !props.api.data[props.propName]
          return
        }
        // изменение значения инпута если функция валидации передана и введенныые данные пришли валидацию
        if (
          !!validateFilterInputs &&
          validateFilterInputs(event, props.propName)
        ) {
          props.api.data[props.propName] = event.target
            ? event.target.value.toString()
            : event.toString()
        }
        // если функция валидации не передана то выполняем изменение значения инпута по умолчанию
        if (validateFilterInputs === undefined) {
          if (validate(event, props.validName)) {
            const value = event.target ? event.target.value : event
            if (onlyNumbers) {
              props.api.data[props.propName] = value.replace(/[^0-9]/g, '')
            } else {
              props.api.data[props.propName] = event?.target
                ? event.target?.value.toString()
                : event?.toString()
            }
          }
        }

        if (autoSearch) {
          props.api.setIsLoaded(false)
        }
      }
    },
    [onChange, validateFilterInputs],
  )

  useEffect(() => {
    if (props.defaultValue) {
      onChangeAction(props.defaultValue)
    }
  }, [])

  return (
    <Box className={'fx-col'} sx={containerStyles}>
      {!!caption && (
        <Box mb={0.5}>
          <Typography variant={'overline'}>{caption}</Typography>
        </Box>
      )}

      <InputField
        value={props.api.data[props.propName]}
        onChange={onChangeAction}
        onPaste={props.paste ? onChangeAction : null}
        error={
          ignoreErrorColor
            ? false
            : error ||
              (props.api.showErrors && props.api.errors[props.propName])
        }
        styles={styles}
        onlyNumbers={onlyNumbers}
        {...props}
      />
    </Box>
  )
}

export default observer(FormInput)
